export default {
	methods: {
		errMsg(attr) {
			return this.v$[attr].$errors[0]?.$message;
		},
	},
};
